var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShuffle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.357 15.234a1 1 0 0 1 1.409.123C14.663 16.427 15.82 17 17 17a1 1 0 1 1 0 2c-1.861 0-3.55-.91-4.766-2.357a1 1 0 0 1 .123-1.409M2 6a1 1 0 0 1 1-1h1c1.058 0 1.979.134 2.819.546.843.414 1.507 1.06 2.138 1.909a1 1 0 0 1-1.605 1.194c-.523-.703-.958-1.083-1.415-1.307C5.477 7.116 4.898 7 4 7H3a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.296 18.844a1 1 0 0 0 0-1.688l-2.76-1.754a1 1 0 0 0-1.536.844v3.508a1 1 0 0 0 1.537.844z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 18a1 1 0 0 0 1 1h1a7 7 0 0 0 6.461-4.308l1.924-4.615A5 5 0 0 1 17 7V5a7 7 0 0 0-6.461 4.308l-1.924 4.615A5 5 0 0 1 4 17H3a1 1 0 0 0-1 1",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.296 6.844a1 1 0 0 0 0-1.688l-2.76-1.754A1 1 0 0 0 16 4.246v3.508a1 1 0 0 0 1.537.844z"
})));
export default SvgIcShuffle;